import { useCallback, useState } from "react";

export function useLocalStorage<T>(
  key: string
): [T | undefined, React.Dispatch<React.SetStateAction<T>>];
export function useLocalStorage<T>(
  key: string,
  initialValue: T
): [T, React.Dispatch<React.SetStateAction<T>>];
export function useLocalStorage<T>(key: string, initialValue?: T) {
  const [storedValue, setStoredValue] = useState<T | undefined>(() => {
    const item = localStorage.getItem(key);
    if (item !== null) return JSON.parse(item);
    if (initialValue !== undefined) {
      localStorage.setItem(key, JSON.stringify(initialValue));
      return initialValue;
    }
    return undefined;
  });

  const setValue = useCallback(
    (value: T | ((prev: T | undefined) => T)) => {
      setStoredValue((prev: T | undefined) => {
        const valueToStore =
          typeof value === "function"
            ? (value as (prev: T | undefined) => T)(prev)
            : value;

        localStorage.setItem(key, JSON.stringify(valueToStore));
        return valueToStore;
      });
    },
    [key]
  );

  return [storedValue as T, setValue] as const;
}
